import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Col, Typography, Input } from 'antd';
import {
  MIN_AMOUNT,
  MAX_AMOUNT,
  COMMERCIAL_KEY_TYPE,
  COMMERCIAL_KEY_VALUE,
  RUPEE_SIGN,
  INFINITY_SIGN,
  PERCENTAGE,
  PERCENTAGE_SIGN
} from './const';

function MarkupSlabList({ markUpSlab }) {
  const [markUpSlabForm] = Form.useForm();
  const markUpSlabKey = 'markUpSlab';

  const checkedModeSlab = markUpSlab?.markUpSlab;

  useEffect(() => {
    if (markUpSlab) {
      markUpSlabForm.setFieldValue([markUpSlabKey], markUpSlab?.markUpSlab);
    }
  });
  return (
    <Form form={markUpSlabForm} layout="vertical" disabled>
      <Form.List name={[markUpSlabKey]}>
        {(fields) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <Row gutter={[32, 32]} key="list">
                <Col span={6}>
                  <Form.Item
                    label={
                      <Typography.Text
                        style={{ color: '#8F93A8', fontWeight: 400, fontSize: '14px' }}
                      >
                        Min Amount{' '}
                      </Typography.Text>
                    }
                    name={[name, MIN_AMOUNT]}
                    key={[name, MIN_AMOUNT]}
                    {...restField}
                  >
                    <Input
                      prefix={RUPEE_SIGN}
                      placeholder="Enter Min Amount"
                      style={{ width: '100%' }}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label={
                      <Typography.Text
                        style={{ color: '#8F93A8', fontWeight: 400, fontSize: '14px' }}
                      >
                        Max Amount{' '}
                      </Typography.Text>
                    }
                    name={
                      checkedModeSlab.at(name).max_amount === 'Infinity'
                        ? [name, '']
                        : [name, MAX_AMOUNT]
                    }
                    key={[name, MAX_AMOUNT]}
                    {...restField}
                  >
                    <Input
                      prefix={
                        checkedModeSlab.at(name).max_amount === 'Infinity'
                          ? INFINITY_SIGN
                          : RUPEE_SIGN
                      }
                      placeholder={
                        checkedModeSlab.at(name).max_amount === 'Infinity' ? '' : 'Enter Max Amount'
                      }
                      style={{ width: '100%' }}
                      disabled
                    />
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    label={
                      <Typography.Text
                        style={{ color: '#8F93A8', fontWeight: 400, fontSize: '14px' }}
                      >
                        Type{' '}
                      </Typography.Text>
                    }
                    name={[name, COMMERCIAL_KEY_TYPE]}
                    key={[name, COMMERCIAL_KEY_TYPE]}
                    {...restField}
                  >
                    <Input
                      placeholder="Please select a type"
                      disabled
                      key={[name, COMMERCIAL_KEY_TYPE]}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label={
                      <Typography.Text
                        style={{ color: '#8F93A8', fontWeight: 400, fontSize: '14px' }}
                      >
                        Charge{' '}
                      </Typography.Text>
                    }
                    name={[name, COMMERCIAL_KEY_VALUE]}
                    key={[name, COMMERCIAL_KEY_VALUE]}
                    {...restField}
                  >
                    <Input
                      prefix={
                        checkedModeSlab.at(name).commercial_type === PERCENTAGE
                          ? PERCENTAGE_SIGN
                          : RUPEE_SIGN
                      }
                      placeholder="Enter Commercial Value"
                      style={{ width: '100%' }}
                      disabled
                    />
                  </Form.Item>
                </Col>
              </Row>
            ))}
          </>
        )}
      </Form.List>
    </Form>
  );
}

MarkupSlabList.propTypes = {
  markUpSlab: PropTypes.instanceOf(Object).isRequired
};

export default MarkupSlabList;
